import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-npst-navyDeep text-slate-300">
        <div className="animate-pulse font-mono text-sm tracking-widest">AUTHENTICATING…</div>
      </div>
    );
  if (!user) return <Navigate to="/admin/login" state={{ from: location }} replace />;
  return children;
}
